import * as React from 'react';
import { observer } from 'mobx-react';
import { inject } from '../utils';
import styled, { withTheme } from 'styled-components';
import { propStyles } from '../utils/propStyles';
import Translate, { translate } from './Translate';
import { FilterStore, TranslationStore } from '../stores';
import Icon from './Icon';

const Wrapper = styled<any, any>('div')`
    ${propStyles};
`;

Wrapper.defaultProps = {};

const Backdrop = styled<any, any>('div')`
    ${propStyles};
    display: flex;
    align-items: flex-start;
    justify-content: center;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    padding-top: 30vh;
`;

Backdrop.defaultProps = {
    zIndex: '10000',
    background: 'rgba(0, 0, 0, 0.5)',
};

const Base = styled<any, any>('div')`
    ${propStyles};
`;

Base.defaultProps = {
    background: 'white',
    display: 'flex',
    flex: {
        direction: 'column',
    },
    zIndex: '10001',
    transition: {
        _value: 'all 0.2s',
    },
    position: 'absolute',
    top: '50%',
    left: '50%',
    margin: 'auto',
    padding: '15px',
    transform: 'translate(-50%, -50%)',
    maxWidth: 'calc(100% - 60px)',
};

const ShareableLinkConfirmText = styled<any, any>('p')`
    ${propStyles};
`;

ShareableLinkConfirmText.defaultProps = {};

interface ShareableLinkConfirmProps {
    theme?: { [property: string]: string | number };
    translationStore?: TranslationStore;
    filterStore?: FilterStore;
}

/**
 * @deprecated
 *
 * The new feedback alert can be styled and used in its place. This includes native accessibility
 */
@inject('translationStore', 'filterStore')
@observer
class ShareableLinkConfirm extends React.Component<ShareableLinkConfirmProps> {
    render() {
        const { theme, translationStore, filterStore } = this.props;

        if (!filterStore.showShareableLinkConfirm) {
            return null;
        }

        return (
            <Wrapper {...theme.ShareableLinkWrapper}>
                <Backdrop {...theme.ShareableLinkBackdrop} />
                <Base {...theme.ShareableLinkBase}>
                    <ShareableLinkConfirmText
                        title={translate(
                            translationStore,
                            filterStore.shareableLinkConfirmation
                        )}
                        {...theme.ShareableLinkConfirmText}
                    >
                        <Translate
                            placeholders={{
                                link: filterStore.shareableLinkHref,
                            }}
                        >
                            {filterStore.shareableLinkConfirmation}
                        </Translate>
                    </ShareableLinkConfirmText>
                    <Icon
                        height="1.4em"
                        width="1.4em"
                        margin="0 0 0 0.25em"
                        fileName="ClearFiltersIcon"
                        {...theme.ClearFiltersIcon}
                        onClick={filterStore.closeShareableLinkConfirm}
                        data-metric-id={`shareableLink-close`}
                    />
                </Base>
            </Wrapper>
        );
    }
}

/**
 * @deprecated
 *
 * The new feedback alert can be styled and used in its place. This includes native accessibility
 */
export default withTheme(ShareableLinkConfirm);



// WEBPACK FOOTER //
// ./src/Components/ShareableLinkConfirm.tsx